import styled from 'styled-components';

import Variables from 'styles/Variables';

export const Wrapper = styled.div`
	max-width: 520px;
	margin: 3rem auto;
	padding: 0 1rem;
`;

export const Content = styled.div`
	text-align: center;
`;

export const IconBadge = styled.div`
	width: 72px;
	height: 72px;
	margin: 0 auto 1.25rem;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${Variables.colors.main};
	color: ${Variables.colors.light};
`;

export const Title = styled.h1`
	font-size: 1.5rem;
	font-weight: 700;
	margin-bottom: 0.5rem;
`;

export const Subtitle = styled.p`
	font-size: 1rem;
	color: #5f5f5f;
	margin-bottom: 1.75rem;

	strong {
		color: ${Variables.colors.dark};
		font-weight: 600;
	}
`;

export const TicketStub = styled.div`
	text-align: left;
	border: 1px solid #eee;
	border-radius: 0.75rem;
	overflow: hidden;
	margin-bottom: 1.5rem;
`;

export const StubHeader = styled.div`
	padding: 0.75rem 1.25rem;
	background-color: ${Variables.colors.main};
	color: ${Variables.colors.light};
	font-size: 0.7rem;
	font-weight: 600;
	letter-spacing: 0.5px;
	text-transform: uppercase;
`;

export const StubBody = styled.div`
	padding: 1.25rem;
`;

export const EventName = styled.p`
	font-size: 1.125rem;
	font-weight: 700;
	margin-bottom: 1.25rem;
`;

export const Divider = styled.div`
	margin: 0 -1.25rem 1.25rem;
	border-top: 1px dashed #ddd;
`;

export const InfoGrid = styled.div`
	display: flex;
	gap: 1.5rem;
`;

export const InfoItem = styled.div`
	flex: 1;
	min-width: 0;
`;

export const InfoLabel = styled.span`
	display: block;
	margin-bottom: 0.25rem;
	font-size: 0.65rem;
	font-weight: 600;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	color: #9b9b9b;
`;

export const InfoValue = styled.span`
	display: block;
	font-size: 0.95rem;
	font-weight: 600;
	color: ${Variables.colors.dark};
	word-break: break-word;
`;
